/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import ContentHub from '@nmx/template/dist/componentLibrary/modules/ContentHub';
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import AdvisorConnectModule from './components/advisorConnectModule';
import HeroSection from './components/heroSection';
import IntroSection from './components/introSection';
import PageContent from './components/pageContent';
import PlanningAndGuidanceSection from './components/planningAndGuidanceSection';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps, contentHubItems } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      disableDisclaimerTopBorder
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Financial Planning',
          linkUrl: '/financial-planning/',
          linkAriaLabel: 'Northwestern Mutual Financial Planning',
        },
        {
          pageName: 'Business Services',
          linkUrl: '/financial-planning/business-services/',
          linkAriaLabel: 'Northwestern Mutual Business Services',
        },
      ]}>

      {/* PAGE CONTENT */}
      <HeroSection />

      {/* INTRO SECTION */}
      <IntroSection />

      {/* ADVISOR CONNECT */}
      <AdvisorConnectModule />

      {/* PAGE CONTENT */}
      <PageContent />

      {/* PLANNING AND GUIDANCE SECTION */}
      <PlanningAndGuidanceSection />

      {/* Content hub */}
      <ContentHub
        sectionId='content-hub'
        backgroundVariant='lightC'
        themeType='lightTheme'
        headingText='Related articles'
        contentHubItems={contentHubItems} // defined in route.js
        config={config}
      />

    </Page>
  );
};
